var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2367 15.7748L15.9104 8.82317C16.0725 8.58243 16.0083 8.25269 15.7694 8.08994C15.5297 7.92719 15.2005 7.99161 15.0393 8.23235L10.7362 14.6322L8.91042 12.6368C8.71375 12.4232 8.37949 12.4105 8.16763 12.608C7.95576 12.8055 7.9431 13.1411 8.13893 13.3548L10.412 15.8384C10.4298 15.8579 10.4534 15.8672 10.4737 15.8833C10.4863 15.8935 10.4939 15.9079 10.5074 15.9172C10.5176 15.924 10.5294 15.9249 10.5403 15.9308C10.5758 15.9511 10.6112 15.9656 10.6501 15.9766C10.6796 15.9859 10.7075 15.9935 10.7379 15.9978C10.7716 16.0012 10.8037 16.0003 10.8383 15.9978C10.8729 15.9952 10.9067 15.991 10.9404 15.9808C10.9691 15.974 10.9945 15.9613 11.0215 15.9486C11.0586 15.9316 11.0924 15.9113 11.1253 15.885C11.1346 15.8774 11.1464 15.8749 11.1548 15.8672C11.1667 15.8562 11.1717 15.8409 11.1818 15.8291C11.1996 15.8096 11.2224 15.7977 11.2367 15.7748Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.30adbd25.svg";
export { ForwardRef as ReactComponent };